import React, { useMemo } from "react";
import { inject, observer } from "mobx-react";
import { IObjectMap } from "../../../interfaces/common";
import { IAppStore } from "../../../stores/Interfaces";
import { Option } from "../../common/forms/Interfaces";
import { PermissionType } from "../../../constants/authorize";
import Select from "./select";

interface Props {
  option: keyof IObjectMap;
  entityKey: string;
  entityId: unknown;
  store?: IAppStore;
  eventKey?: string;
  permission?: PermissionType;
  multiple?: boolean;
}

const Client: React.FC<Props> = ({
  option,
  entityKey,
  entityId,
  store,
  eventKey,
  permission,
}) => {
  const options = useMemo((): Option[] => {
    const items: Option[] = [];

    if (store?.settingsStore.clients) {
      items.push(...store.settingsStore.clients);
    }

    return items;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store, store?.settingsStore.clients]);

  if (permission && store?.userStore.authorizeByPermission(permission)) {
    return (
      <Select
        options={options}
        entityKey={entityKey}
        entityId={entityId}
        string={option}
        eventKey={eventKey}
        showSearch
      />
    );
  }

  return <>{option}</>;
};
export default inject("store")(observer(Client));
